import { render, staticRenderFns } from "./clothDetail.vue?vue&type=template&id=3977e81b&scoped=true"
import script from "./clothDetail.vue?vue&type=script&lang=js"
export * from "./clothDetail.vue?vue&type=script&lang=js"
import style0 from "./clothDetail.vue?vue&type=style&index=0&id=3977e81b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977e81b",
  null
  
)

export default component.exports